import { Component, TemplateRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TableConfig } from '../interfaces';

/** What the renderer reads from the hosting table component (grid context) */
export interface RowActionsHost {
    tableConfig?: TableConfig;
}

export interface RowActionsCellRendererParams extends ICellRendererParams {
    context: RowActionsHost;
    /** The consumer's `rowActions` ng-template, rendered after the buttons */
    template?: TemplateRef<unknown>;
}

/**
 * The rightmost actions column: the `tableConfig.actions` icon buttons as in
 * static-table (delete styling, tooltip, per-row disabled function), followed
 * by the consumer's `rowActions` template. The actions are read live from the
 * host's tableConfig through the grid context, so changing them never
 * requires the column definitions to be rebuilt. Rows are RenderedRow
 * wrappers, so the original row is `data.data`.
 */
@Component({
    selector: 'row-actions-cell-renderer',
    template: `
        <ng-container
            *ngFor="let action of params.context?.tableConfig?.actions"
        >
            <button
                type="button"
                class="btn btn-tertiary"
                [class.btn-delete]="action.icon === 'fal fa-trash-alt'"
                [tooltip]="action.tooltip"
                placement="left"
                [disabled]="
                    params.data?.data | evaluateOrDefault: action.disabled:false
                "
                (click)="action.action(params.data?.data)"
            >
                <span [ngClass]="action.icon"></span>
            </button>
        </ng-container>
        <ng-container
            *ngIf="params.template"
            [ngTemplateOutlet]="params.template"
            [ngTemplateOutletContext]="{ row: params.data?.data }"
        ></ng-container>
    `
})
export class RowActionsCellRenderer implements ICellRendererAngularComp {
    params: RowActionsCellRendererParams;

    agInit(params: RowActionsCellRendererParams) {
        this.params = params;
    }

    refresh(params: RowActionsCellRendererParams) {
        this.params = params;
        return true;
    }
}
